import $ from 'jquery'
import Isotope from "isotope-layout";

function initPluginIsotope() {


    $(document).ready(function() {
        let currentFilter = '*';

        const $grid = document.querySelector('#grid');
        const iso = new Isotope($grid, {
            itemSelector: '.grid-item',
            layoutMode: 'masonry',
            filter: function(item){
                const categories = $(item).attr('data-categories').split(' ');
                return categories.some(category => currentFilter === '*' || category === currentFilter)
            }
        });

        $('.filter').on('click', function(e) {
            currentFilter = $(this).attr('data-filter');

            let descriptions = document.getElementsByClassName('category-description')
            console.log(descriptions)
            for (let description of descriptions){
                if(description.classList.contains('d-block')) {
                    description.classList.remove('d-block')
                    description.classList.add('d-none')
                }
            }
            if(currentFilter !== '*'){
                let currentDescription = document.getElementById(currentFilter+'-description')
                if(currentDescription) {
                    currentDescription.classList.add('d-block')
                    currentDescription.classList.remove('d-none')
                }

            }

            for(let child of e.currentTarget.parentElement.children){
                if(child.classList.contains('btn-primary')){
                    child.classList.remove('btn-primary')
                    child.classList.add('btn-outline-primary')
                    break;
                }
            }

            if(e.currentTarget.classList.contains('btn-outline-primary'))
                e.currentTarget.classList.remove('btn-outline-primary')
            e.currentTarget.classList.add('btn-primary')
            iso.arrange();
        });
    });

}

export { initPluginIsotope };
